/** @module Classes */ /** typedoc */
class LibraryItem {
    constructor() {
        this.id = null;
        this.type = null;
        this.name = null;
        this.productCode = null;
        this.intensity = null;
        this.productionStyle = null;
        this.referenceTrackName = null;
        this.isAtLeastCdAudioQuality = null;
        this.alreadyReleased = null;
        this.originalId = null;
        this.versionId = null;
    }
}
const keysOfLibraryItem = ["id", "type", "name", "productCode", "intensity", "productionStyle", "referenceTrackName", "isAtLeastCdAudioQuality", "alreadyReleased", "originalId", "versionId"];

export { LibraryItem, keysOfLibraryItem };
